
/* FAQ TOGGLE */
$('.faq-item').click(function() {
    $(this).toggleClass('open');
});